/* eslint-disable react/no-multi-comp, react/prop-types */
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import { CardMetadata } from 'components/content-containers/cards';
import { MetadataTable, MetadataItem } from 'components/content-containers/tables';

// Component
function PurchaseMetadata({ ticket, date, vendor, company, approvedBy, purchasedBy, replenishment, className }) {
  const tableClassName = classNames('fixed-table', className);
  
  return (
    <CardMetadata>
      <MetadataTable className={tableClassName} header={<MetadataHeader />}>
        <MetadataItem label="Company">
          {company}
        </MetadataItem>
        <MetadataItem label="Ticket">
          {ticket}
        </MetadataItem>
        <MetadataItem label="Date">
          {date}
        </MetadataItem>
      </MetadataTable>
      <MetadataTable className={tableClassName} header={<MetadataHeader />}>
        <MetadataItem label="Purchased By">
          {purchasedBy}
        </MetadataItem>
        <MetadataItem label="Vendor">
          {vendor}
        </MetadataItem>
        <MetadataItem label="Client approver">
          {approvedBy}
        </MetadataItem>
        <MetadataItem label="Replenishment">
          {replenishment}
        </MetadataItem>
      </MetadataTable>
    </CardMetadata>
  );
}

// Prop types
PurchaseMetadata.propTypes = {
  ticket: PropTypes.node,
  date: PropTypes.node,
  vendor: PropTypes.node,
  company: PropTypes.node,
  approvedBy: PropTypes.node,
  purchasedBy: PropTypes.node,
  replenishment: PropTypes.node
};

export default PurchaseMetadata;


// Internal component
function MetadataHeader() {
  return (
    <thead>
      <tr className="invisible-row">
        <th className="col-medium" />
        <th className="col-xl" />
      </tr>
    </thead>
  );
}
